import { css } from "@emotion/react";
import CastInfo from "./CastInfo";
import {
  konnoAyaka,
  hondaMiyu,
  masudaToshiki,
  hukahoriMiku,
  kusakawaTakuya,
  minetaHiromu,
  shinYuki,
  umedaShuichirou,
  kumagaiKentarou,
  yamashitaSeiichirou,
  tachibanaTatsumaru,
  ozakiYuka,
  nakazhimaMegumi,
  koichiMakoto,
} from "./casts";

const Casts: React.FC = () => {
  return (
    <>
      <div css={topWhiteSpaceStyle}></div>
      <div css={mainStyle} id="cast">
        <div css={containerStyle}>
          <div css={contentsWrapper}>
            <div css={upperTitleWrapperStyle}>
              <div css={borderStyle}></div>
              <div css={titleStyle}>キャスト</div>
              <div css={borderStyle}></div>
            </div>
            <img
              src={
                process.env.REACT_APP_ASSET_BASE_PATH + "/img/hayakawa-yui.png"
              }
              alt="速川 唯 役"
              css={castImgStyle(10, 240)}
            />
            <CastInfo
              actorFileName="honda-miyu.png"
              alt="本田 望結"
              txt={hondaMiyu}
              isTop
            />
            <CastInfo
              actorFileName="konno-ayaka.png"
              alt="紺野 彩夏"
              txt={konnoAyaka}
              isBottom
            />
            <div css={bottomBorderWrapperStyle}>
              <div css={borderStyle}></div>
            </div>
            <img
              src={
                process.env.REACT_APP_ASSET_BASE_PATH +
                "/img/hagi-kuhatirou.png"
              }
              alt="羽木九八郎 忠清 役"
              css={castImgStyle(30, 190)}
            />
            <CastInfo
              actorFileName="masuda-toshiki.png"
              alt="増田 俊樹"
              txt={masudaToshiki}
              isTop
            />
            <CastInfo
              actorFileName="fukahori-miku.png"
              alt="深堀 未来 (BALLISTIK BOYS)"
              txt={hukahoriMiku}
            />
            <CastInfo
              actorFileName="kusakawa-takuya.png"
              alt="草川 拓哉 (超特急)"
              txt={kusakawaTakuya}
              isBottom
            />
            <div css={bottomBorderWrapperStyle}>
              <div css={borderStyle}></div>
            </div>
            <img
              src={
                process.env.REACT_APP_ASSET_BASE_PATH +
                "/img/hayakawa-takeru.png"
              }
              alt="速川 尊 役"
              css={castImgStyle(30, 269)}
            />
            <CastInfo
              actorFileName="mineta-hiromu.png"
              alt="峯田 大夢"
              txt={minetaHiromu}
              isTop
            />
            <CastInfo
              actorFileName="shin-yuki.png"
              alt="新 祐樹"
              txt={shinYuki}
            />
            <CastInfo
              actorFileName="umeda-shuichirou.png"
              alt="梅田 修一郎"
              txt={umedaShuichirou}
              isBottom
            />
            <div css={bottomBorderWrapperStyle}>
              <div css={borderStyle}></div>
            </div>
            <img
              src={
                process.env.REACT_APP_ASSET_BASE_PATH + "/img/hagi-nariyuki.png"
              }
              alt="羽木 成之 役"
              css={castImgStyle(30, 160)}
            />
            <CastInfo
              actorFileName="kumagai-kentarou.png"
              alt="熊谷 健太郎"
              txt={kumagaiKentarou}
              isTop
            />
            <CastInfo
              actorFileName="yamashita-seiichirou.png"
              alt="山下 誠一郎"
              txt={yamashitaSeiichirou}
            />
            <CastInfo
              actorFileName="tachibana-tatsumaru.png"
              alt="橘 龍丸"
              txt={tachibanaTatsumaru}
              isBottom
            />
            <div css={bottomBorderWrapperStyle}>
              <div css={borderStyle}></div>
            </div>
            <img
              src={
                process.env.REACT_APP_ASSET_BASE_PATH + "/img/matsumaru-ako.png"
              }
              alt="松丸 阿湖 役"
              css={castImgStyle(30, 154)}
            />
            <CastInfo
              actorFileName="ozaki-yuka.png"
              alt="尾崎 由香"
              txt={ozakiYuka}
              isTop
            />
            <CastInfo
              actorFileName="nakazhima-megumi.png"
              alt="中島 愛"
              txt={nakazhimaMegumi}
            />
            <CastInfo
              actorFileName="koichi-makoto.png"
              alt="小市 眞琴"
              txt={koichiMakoto}
              isBottom
            />
            <div css={bottomBorderWrapperStyle}>
              <div css={borderStyle}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const primaryColor = "#DD6B74";

const mainStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const topWhiteSpaceStyle = css`
  width: 100%;
  height: 20px;
  background-color: #fff;
`;

const containerStyle = css`
  width: 100%;
  max-width: 500px;
  padding: 10px 20px 20px;
  @media (min-width: 768px) {
    padding: 0px 30px 30px;
  }
`;

const contentsWrapper = css`
  padding-bottom: 30px;

  @media (min-width: 768px) {
    margin-top: 5px;
    border: 1px solid ${primaryColor};
  }
`;

const upperTitleWrapperStyle = css`
  display: flex;
  align-items: center;
  padding: 30px 30px 20px;
`;

const bottomBorderWrapperStyle = css`
  padding: 0 30px;
  display: flex;
  align-items: center;
`;

const borderStyle = css`
  height: 1px;
  background-color: ${primaryColor};
  flex-grow: 1;
`;

const titleStyle = css`
  margin: 0 10px;
  font-size: 12pt;
  font-weight: 500;
`;

const castImgStyle = (marginTop: number, width: number) => css`
  margin: ${marginTop || 30}px 0 20px;
  width: ${width}px;
`;

export default Casts;
